import { createContext, type ReactNode, useContext } from "react";
import type { FractionClient } from "../api/FractionClient";

/**
 * Holds the FractionClient instance for the app. Both web and mobile wrap
 * their root with `<FractionClientProvider client={fraction}>` so the shared
 * hooks in `@fraction/shared-frontend/hooks` can read the client without
 * each app having to thread the singleton through props.
 */
const FractionClientContext = createContext<FractionClient | null>(null);

export function FractionClientProvider({
  client,
  children,
}: {
  client: FractionClient;
  children: ReactNode;
}) {
  return <FractionClientContext.Provider value={client}>{children}</FractionClientContext.Provider>;
}

export function useFractionClient(): FractionClient {
  const client = useContext(FractionClientContext);
  if (!client) {
    throw new Error(
      "useFractionClient() must be used inside <FractionClientProvider>. Wrap your app root with it."
    );
  }
  return client;
}
